// 通用类，是reportItemCode的完善版，H5使用itemcode打点方式，类比客户端
// 页面渲染完之后初始化
// 打点参数全部从dom的data-属性中获取
import $ from "zepto";
import wkReader from './wkreader';
import API from "../../api/API";
import Utils from "./utils";

class Report {
  constructor(config) {
    // console.log(config)
    this.allParam = Utils.getAllParam()
    this.token_key = config['token_key'] || Utils.getUrlParam('token_key')
    this.report_ele = config['report_ele'] || '.report'
    this.reportItem = []
    this.page_code = config['page_code']
    this.extSourceId = config['extSourceId'] || Utils.getUrlParam('extSourceId')
    this.originReportData = wkReader.BuildEventParams() || '{}'
    this.extendData = config['extend_data'] || {}
    this.pageViewData = config['pageview_data'] || {}
    this.reportTempList = []    // 临时存储要打点的数据
    console.log('this.originReportData', this.originReportData)
    let _this = this
    // 获取必要信息之后，获取要上报的item
    if (!config.noAuto) {
      if (!config.no_page_show) {
        _this.reportPageData()    // 页面曝光事件
      }
      setTimeout(() => {
        // _this.getReportItem()    // 获取需要打点的元素以及其信息
        // _this.cacheReportData(0)  // 缓存要打点的数据
        // _this.reportCache()       // 将临时列表一次性打点
        _this.reportViewportElem(0)
      }, 200);

      // window滚动上报show
      let timeout = null
      $(window).off().on('scroll', function () {
        let hasScrollTop = $(this).scrollTop()

        if (timeout) { clearTimeout(timeout); }
        timeout = setTimeout(() => {
          // _this.getReportItem()
          // _this.cacheReportData(hasScrollTop)
          // _this.reportCache()
          _this.reportViewportElem(hasScrollTop)
        }, 200);
      })

      // 点击上报click
      $('body').off().on('click', this.report_ele, function () {
        _this.reportClickData($(this))
      })
    }
  }
  // 判断元素是否在视口内
  isElementInViewport($el) {
    // console.log('$el :>> ', $el);
    const rect = $el[0].getBoundingClientRect();
    // console.log('rect :>> ', rect);
    const windowHeight = $(window).height();
    const windowWidth = $(window).width();
    // const scrollTop = $(window).scrollTop();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= windowHeight &&
      rect.right <= windowWidth
    );
  }

  // 上报视口内的元素
  reportViewportElem (scrollTop) { 
    // console.log('曝光 :>> ');
    this.getReportItem()
    this.cacheReportData(scrollTop)
    this.reportCache()
  }

  // 获取滚动需要打点元素和数据
  getReportItem () {
    let windowHeight = $(window).height()
    let tempList = []
    // console.log('$(this.report_ele)', $(this.report_ele))
    $(this.report_ele).each((index, item) => {
      if (!$(item).hasClass('disabled') && !$(item).hasClass('view-disabled')) {
        let start = $(item).offset().top - windowHeight
        tempList.push({
          display: $(item).css('display'),
          height: $(item).height(),
          start: start,
          end: $(item).offset().top + $(item).height(),
          itemcode: $(item).data('itemcode'),
          poscode: $(item).data('poscode'),
          scbookid: $(item).data('scbookid'),
          book_id: $(item).data('book_id'),
          commodity_id: $(item).data('commodity_id'),
          hasReport: false,
          otherData: Object.assign({}, $(item)[0].dataset, this.extendData),
          element: item,
        })
      }
    })
    // 这里不要直接赋值，因为有些已经report过了，不要重复
    // console.log('tempList', tempList)
    let temp = []
    // let temp = JSON.parse(JSON.stringify(this.reportItem))
    for (let i = 0; i < tempList.length; i++) {
      let item = tempList[i];
      let flag = false  // 假设没有report过
      for (let j = 0; j < this.reportItem.length; j++) {
        let jtem = this.reportItem[j];
        if(JSON.stringify(item.otherData) == JSON.stringify(jtem.otherData)){ // 根据属性来判断是否相同
          // console.log('相同元素======', item, jtem)
          flag = true
          item.hasReport = jtem.hasReport // 保留之前的上报状态，同一屏防止重复上报
          break
        }
        continue

        if (item.itemcode) {
          if (item.scbookid) { // 原书籍id, 暂时继续保留
            // 书籍
            if (jtem.scbookid == item.scbookid) {
              flag = true
              item.hasReport = jtem.hasReport
              break
            }
          }else if(item.book_id){ // 书籍
            if (jtem.book_id == item.book_id) {
              flag = true
              item.hasReport = jtem.hasReport
              break
            }
          }else if(item.commodity_id){ // 商品
            if (jtem.commodity_id == item.commodity_id) {
              flag = true
              item.hasReport = jtem.hasReport
              break
            }
          } else {
            // 非书籍
            if (jtem.itemcode == item.itemcode) { // 可能会有重复的itemcode，导致漏报
              flag = true
              item.hasReport = jtem.hasReport
              break
            }
          }
        } else {
          continue;
        }
      }
      if (!flag) {
        temp.push(item)
        // this.reportItem.push(item)
      }
    }
    this.reportItem = tempList
    // this.reportItem.push(...temp)
    // console.log('reportItem', this.reportItem)
  }

  // 暂存上报事件
  cacheReportData (hasScrollTop) {
    this.reportItem.forEach(item => {
      if (item.display !== 'none') {
        // if (hasScrollTop >= item.start && hasScrollTop <= item.end && !item.hasReport) {
        if (this.isElementInViewport($(item.element)) && !item.hasReport) {
          let res = $.extend({}, {
            poscode: item.poscode,
            itemcode: item.itemcode,
            starttime: new Date().getTime(),
            version_code: this.version_code,
            report_type: 1,
          }, item.otherData)
          this.reportTempList.push(res)
          item.hasReport = true
        }
        // if (hasScrollTop < item.start || hasScrollTop > item.end) {
        if (!this.isElementInViewport($(item.element))) {
          item.hasReport = false
        }
      }
    });
  }

  reportCache () {
    // console.log('this.reportTempList', this.reportTempList)
    if (this.reportTempList.length > 0) {
      this.defaultReport(this.reportTempList)
      this.reportTempList = []
    }
  }


  // 页面曝光事件
  reportPageData (created = false) {
    this.defaultReport([Object.assign({}, {
      report_type: 0,
      action_type: 'open',      // 和客户端统一，客户端有开启和关闭页面的判断
      starttime: new Date().getTime(),
      version_code: this.version_code,
      created: created,
    }, this.pageViewData, this.extendData)])
  }

  // 点击上报事件
  reportClickData (ele) {
    if (ele.hasClass('disabled')) { return }
    if (ele.hasClass('click-disabled')) { return } //
    let res = $.extend({}, {
      poscode: ele.data('poscode') || '',
      itemcode: ele.data('itemcode') || '',
      scbookid: ele.data('scbookid') || '',
      starttime: new Date().getTime(),
      version_code: this.version_code,
      report_type: 2,
    }, ele[0].dataset, this.extendData)
    this.defaultReport([res])
  }


  // 手动曝光上报事件，只有状态改变时需要手动曝光一个元素时调用
  reportShowOneData (ele) {
    if (ele.hasClass('disabled')) { return }
    let res = $.extend({}, {
      poscode: ele.data('poscode') || '',
      itemcode: ele.data('itemcode') || '',
      scbookid: ele.data('scbookid') || '',
      starttime: new Date().getTime(),
      version_code: this.version_code,
      report_type: 1,
    }, ele[0].dataset, this.extendData)
    this.defaultReport([res])
  }

  // 自定义事件
  reportDIYData (ele) {
    let res = $.extend({}, {
      poscode: ele.data('poscode') || '',
      itemcode: ele.data('itemcode') || '',
      scbookid: ele.data('scbookid') || '',
      starttime: new Date().getTime(),
      version_code: this.version_code,
      report_type: 3,
    }, ele[0].dataset, this.extendData)
    this.defaultReport([res])
  }

  defaultReport (list, success, fail) {
    let url = API.report
    let ext = {}
    let data = []
    list.forEach(item => {
      let originReportData = JSON.parse(this.originReportData)
      ext = $.extend({}, originReportData.ext, item, this.allParam)
      data.push($.extend({}, originReportData, {
        "logtype": "h5",
        "report_type": item.report_type,
        "pagecode": this.page_code || '',
        "poscode": item.poscode || '',
        "itemcode": item.itemcode || '',
        "starttime": item.starttime || '',
        "scbookid": item.scbookid || '',
        "extSourceId": this.extSourceId || '',
        "ext": ext
      }))
    });
    console.log('report data', data);
    let body = JSON.stringify(data)
    $.ajax({
      type: "POST",
      url: url,
      data: {
        token_key: this.token_key || '',
        body: body
      },
      success: success,
      error: fail
    })
  }
}

export default Report



// WEBPACK FOOTER //
// ./src/common/js/report.js